import { render, staticRenderFns } from "./PropertyMaintenanceSystemName.vue?vue&type=template&id=70af97e5"
import script from "./PropertyMaintenanceSystemName.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports